import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  SalesOrderCreateRequestDTO,
  SalesOrderDeleteRequestDTO,
  SalesOrderDTO,
  SalesOrderList,
  SalesOrderReadByIdRequestDTO,
  SalesOrderReadByProjectIdRequestDTO,
  SalesOrderReadByAgentIdRequestDTO,
  SalesOrderReadByTenantIdRequestDTO,
  SalesOrderSearchByOrderNoRequestDTO,
  SalesOrderUpdateRequestDTO
} from 'src/app/sale/sales-order/sales-order.interface';

import {
   SalesOrder_Create,
  SalesOrder_Update,
  SalesOrder_Delete,
  SalesOrder_ReadById,
  SalesOrder_ReadByProjectId,
  SalesOrder_ReadAll,
  SalesOrder_ReadByAgentId,
  SalesOrder_ReadByTenantId,
  SalesOrder_SearchByOrderNo,
  SalesOrderOtherCharges_Create,
  SalesOrderOtherCharges_Update,
  SalesOrderOtherCharges_Delete,
  SalesOrderOtherCharges_ReadById,
  SalesOrderOtherCharges_ReadBySalesOrderId
} from 'src/app/GlobalVariables';


import {
  SalesOrderOtherChargesCreateRequestDTO,
  SalesOrderOtherChargesUpdateRequestDTO,
  SalesOrderOtherChargesDeleteRequestDTO,
  SalesOrderOtherChargesReadBySalesOrderIdRequestDTO,
  SalesOrderOtherChargesReadByIdRequestDTO,
  SalesOrderOtherChargesDTO,
  SalesOrderOtherChargesList
} from 'src/app/sale/sales-order/salesorderOthercharges.interface';


@Injectable({
  providedIn: 'root'
})
export class SalesOrderService {

  http = inject(HttpClient);

   /* ================= CREATE ================= */
  SalesOrder_Create(
    data: SalesOrderCreateRequestDTO
  ): Observable<SalesOrderDTO> {
    return this.http.post<SalesOrderDTO>(SalesOrder_Create, data);
  }

  /* ================= UPDATE ================= */
  SalesOrder_Update(
    data: SalesOrderUpdateRequestDTO
  ): Observable<SalesOrderDTO> {
    return this.http.post<SalesOrderDTO>(SalesOrder_Update, data);
  }

  /* ================= DELETE ================= */
  SalesOrder_Delete(
    data: SalesOrderDeleteRequestDTO
  ): Observable<void> {
    return this.http.post<void>(SalesOrder_Delete, data);
  }

  /* ================= READ ================= */
  SalesOrder_ReadById(
    data: SalesOrderReadByIdRequestDTO
  ): Observable<SalesOrderDTO> {
    return this.http.post<SalesOrderDTO>(SalesOrder_ReadById, data);
  }

  SalesOrder_ReadByProjectId(
    data: SalesOrderReadByProjectIdRequestDTO
  ): Observable<SalesOrderList> {
    return this.http.post<SalesOrderList>(SalesOrder_ReadByProjectId, data);
  }

  SalesOrder_ReadByAgentId(
    data: SalesOrderReadByAgentIdRequestDTO
  ): Observable<SalesOrderList> {
    return this.http.post<SalesOrderList>(SalesOrder_ReadByAgentId, data);
  }

  SalesOrder_ReadByTenantId(
    data: SalesOrderReadByTenantIdRequestDTO
  ): Observable<SalesOrderList> {
    return this.http.post<SalesOrderList>(SalesOrder_ReadByTenantId, data);
  }

  /* ================= SEARCH ================= */
  SalesOrder_SearchByOrderNo(
    data: SalesOrderSearchByOrderNoRequestDTO
  ): Observable<SalesOrderList> {
    return this.http.post<SalesOrderList>(SalesOrder_SearchByOrderNo, data);
  }

  /* ================= READ ALL ================= */
  SalesOrder_ReadAll(): Observable<SalesOrderList> {
    return this.http.get<SalesOrderList>(SalesOrder_ReadAll);
  }



 /* ================= SALES ORDER OTHER CHARGES ================= */

  SalesOrderOtherCharges_create(
    data: SalesOrderOtherChargesCreateRequestDTO
  ): Observable<SalesOrderOtherChargesDTO> {
    return this.http.post<SalesOrderOtherChargesDTO>(
      SalesOrderOtherCharges_Create,
      data
    );
  }

  SalesOrderOtherCharges_update(
    data: SalesOrderOtherChargesUpdateRequestDTO
  ): Observable<SalesOrderOtherChargesDTO> {
    return this.http.post<SalesOrderOtherChargesDTO>(
      SalesOrderOtherCharges_Update,
      data
    );
  }

  SalesOrderOtherCharges_delete(
    data: SalesOrderOtherChargesDeleteRequestDTO
  ): Observable<void> {
    return this.http.post<void>(
      SalesOrderOtherCharges_Delete,
      data
    );
  }

  SalesOrderOtherCharges_readByOrderId(
    data: SalesOrderOtherChargesReadBySalesOrderIdRequestDTO
  ): Observable<SalesOrderOtherChargesList> {
    return this.http.post<SalesOrderOtherChargesList>(
      SalesOrderOtherCharges_ReadBySalesOrderId,
      data
    );
  }

  SalesOrderOtherCharges_readById(
    data: SalesOrderOtherChargesReadByIdRequestDTO
  ): Observable<SalesOrderOtherChargesDTO> {
    return this.http.post<SalesOrderOtherChargesDTO>(
      SalesOrderOtherCharges_ReadById,
      data
    );
  }
}
